import axios from "axios";

const instance = axios.create({
    //baseURL: 'https://localhost:9876',//DEV
    baseURL: 'https://new.geticketsonline.com',//PROD
});

instance.interceptors.request.use(async(config) => {
    config.headers.ContentType = "application/json";
    return config;
});

export const getAll = async(param,date) =>
    await instance.post("report/events/all",{param,date});

export const eventByDateReport = async(eventDateId) =>
    await instance.post("report/sales/byeventdate",{eventDateId})

export const eventBySingleDayReport = async(date) =>
    await instance.post("event/bydate/singledate",{date})